import {
  locationIdFormat,
  productIdFormat,
  storageLocationIdFormat,
  taskIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const createCycleCount = {
  name: "createCycleCount" as const,
  input: z.object({
    name: z.string().min(1),
    locationId: locationIdFormat.schema,
    assignedUserId: z.string().optional(),
    assignedRole: z.string().optional(),
    productIds: z.array(productIdFormat.schema).default([]),
    storageLocationIds: z.array(storageLocationIdFormat.schema).default([]),
  }),
  output: z.object({ taskId: taskIdFormat.schema }),
};
